import thunk from 'redux-thunk';
import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import i18n from '../i18n';
import { addAlert } from './alertActions';

export function errorHandler(dispatch, error, type) {
    let errorMessage = '';
    if (error?.status === 401 || error?.status === 400) {
        dispatch(addAlert({
            message: i18n.t('vimeo.invalid-code'),
            view: '/modules/sermons',
            type: 'error',
            id: 'invalid-login',
            dismissable: true,
        }));
    } else {
        errorMessage = handleError(error);
    }
    dispatch({
        type,
        error: errorMessage,
    });

    const clearError = () => {
        dispatch({
            type,
            error: '',
        });
    };

    setTimeout(clearError, 3000);
}

export function getVimeoToken(code, projectId, redirect) {
    return function (dispatch) {
        return axios
            .put(`${window.GENESIS_CMS_API_URL}/v2/vimeo/${projectId}/getToken?token=${window.genesisToken()}&code=${code}&redirect=${redirect}&sessionId=${localStorage.getItem('SessionId')}`)

            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_VERSION_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_VIMEO_FEED_TOKEN);
            });
    };
}

export function getVimeoFeeds(token) {
    return function (dispatch) {
        // get all albums https://api.vimeo.com/me/albums?fields=name,uri
        // get all channels https://api.vimeo.com/me/channels?filter=moderated&fields=name,uri
        // get all portfolios. Using this adds to QA load so this is staying commented out https://api.vimeo.com/me/portfolios?fields=name,uri
        // all uploaded videos will live at https://api.vimeo.com/me/videos - we do not need to make a request to know this

        let retObj = [];
        retObj.push({
            uri: '/me',
            name: 'All uploaded videos',
        });

        const getChannels = () => {
            return axios({
                method: 'GET',
                url: 'https://api.vimeo.com/me/channels?filter=moderated&fields=name,uri',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'content-type': 'application/json',
                    Accept: 'application/vnd.vimeo.*+json;version=3.4',
                },
            })
                .then((response) => {
                    retObj = retObj.concat(response.data.data);
                });
        };
        const getShowcases = () => {
            return axios({
                method: 'GET',
                url: 'https://api.vimeo.com/me/albums?fields=name,uri',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'content-type': 'application/json',
                    Accept: 'application/vnd.vimeo.*+json;version=3.4',
                },
            })
                .then((response) => {
                    retObj = retObj.concat(response.data.data);
                    dispatch({
                        type: types.GET_VIMEO_FEEDS_LIST_SUCCESS,
                        payload: {
                            data: retObj,
                        },
                    });
                });
        };
        const handleErrorFn = (error) => {
            errorHandler(dispatch, error.response, types.GET_VIMEO_FEEDS_LIST_FAILED);
        };

        return getChannels()
            // .then(getPortfolios)
            .then(getShowcases)
            .catch(handleErrorFn);
    };
}
